<template>
  <div
    ref="kt_modal_faturamento_editar_veic_transp"
    data-bs-backdrop="static"
    data-bs-focus="false"
    class="modal fade modal-overlay"
    tabindex="-1"
    id="kt_modal_faturamento_editar_veic_transp"
    data-bs-keyboard="false"
  >
    <div
      class="modal-dialog modal-lg modal-dialog-centered modal-dialog-scrollable"
    >
      <div class="modal-content">
        <div class="modal-header">
          <div class="card-title d-flex align-items-center">
            <span class="svg-icon svg-icon-1 svg-icon me-3 lh-0">
              <inline-svg src="media/icons/duotune/general/gen005.svg" />
            </span>
            <h3 class="fw-bold m-0 text-gray-800">Veículo Transporte</h3>
          </div>
          <div
            class="btn btn-icon btn-sm btn-active-light-primary"
            @click="cancelar()"
          >
            <span class="svg-icon svg-icon-1 svg-icon lh-0">
              <inline-svg src="media/icons/duotune/arrows/arr061.svg" />
            </span>
          </div>
        </div>
        <div class="modal-body p-5">
          <div class="row">
            <div
              class="col-sm-12 col-md-12 col-lg-12 col-xl-4 col-xxl-4 fv-row mb-6"
            >
              <label class="form-label">Placa</label>
              <input
                type="text"
                :class="[
                  'form-control mb-2',
                  errosValidacao['placa'] ? 'is-invalid' : '',
                ]"
                v-model="this.refVeicTransp.placa"
                maxlength="7"
                id="txtPlaca"
              />
              <div class="fv-plugins-message-container invalid-feedback">
                {{ errosValidacao["placa"] }}
              </div>
            </div>
            <div
              class="col-sm-12 col-md-12 col-lg-12 col-xl-4 col-xxl-4 fv-row mb-6"
            >
              <label class="form-label">UF</label>
              <select
                :class="[
                  'form-select',
                  errosValidacao['UF'] ? 'is-invalid' : '',
                ]"
                v-model="this.refVeicTransp.UF"
              >
                <option value="AC">Acre</option>
                <option value="AL">Alagoas</option>
                <option value="AP">Amapá</option>
                <option value="AM">Amazonas</option>
                <option value="BA">Bahia</option>
                <option value="CE">Ceara</option>
                <option value="DF">Distrito Federal</option>
                <option value="ES">Espirito Santo</option>
                <option value="GO">Goiás</option>
                <option value="MA">Maranhão</option>
                <option value="MT">Mato Grosso</option>
                <option value="MS">Mato Grosso do Sul</option>
                <option value="MG">Minas Gerais</option>
                <option value="PA">Para</option>
                <option value="PB">Paraíba</option>
                <option value="PR">Paraná</option>
                <option value="PE">Pernambuco</option>
                <option value="PI">Piauí</option>
                <option value="RJ">Rio de Janeiro</option>
                <option value="RN">Rio Grande do Norte</option>
                <option value="RS">Rio Grande do Sul</option>
                <option value="RO">Rondônia</option>
                <option value="RR">Roraima</option>
                <option value="SC">Santa Catarina</option>
                <option value="SP">São Paulo</option>
                <option value="SE">Sergipe</option>
                <option value="TO">Tocantins</option>
                <option value="EX">Exterior</option>
              </select>
              <div class="fv-plugins-message-container invalid-feedback">
                {{ errosValidacao["UF"] }}
              </div>
            </div>
            <div
              class="col-sm-12 col-md-12 col-lg-12 col-xl-4 col-xxl-4 fv-row mb-6"
            >
              <label class="form-label">RNTC</label>
              <input
                type="text"
                :class="[
                  'form-control mb-2',
                  errosValidacao['RNTC'] ? 'is-invalid' : '',
                ]"
                v-model="this.refVeicTransp.RNTC"
                maxlength="20"
              />
              <div class="fv-plugins-message-container invalid-feedback">
                {{ errosValidacao["RNTC"] }}
              </div>
            </div>
          </div>
        </div>
        <div class="modal-footer d-flex justify-content-end">
          <button
            class="btn btn-danger svg-icon-white me-2 mb-2"
            @click="cancelar()"
          >
            <span class="svg-icon svg-icon-1">
              <inline-svg
                src="media/icons/duotune/arrows/arr015.svg"
                class="me-2"
              />Cancelar
            </span>
          </button>
          <button
            class="btn btn-success svg-icon-white mb-2"
            @click="confirmar()"
            v-bind:data-kt-indicator="this.loading ? 'on' : 'off'"
          >
            <span class="indicator-progress">
              <span
                class="spinner-border spinner-border-sm align-middle ms-1"
              ></span>
              Aguarde...
            </span>
            <span class="svg-icon svg-icon-1" v-if="!this.loading">
              <inline-svg
                src="media/icons/duotune/arrows/arr016.svg"
                class="me-2"
              />Confirmar
            </span>
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { hideModal } from "@/core/helpers/dom";
import Swal from "sweetalert2/dist/sweetalert2.min.js";

const veicTranspInicializado = {
  placa: "",
  uf: "",
  RNTC: "",
};

export default {
  emits: [
    "exibirModalEditarVeicTransp",
    "adicionarVeicTransp",
    "editarVeicTransp",
  ],
  props: {
    index: { type: Number, required: true, default: -1 },
    refVeicTranspFaturamento: { type: Object, required: true },
  },
  methods: {
    async confirmar() {
      this.errosValidacao = {};
      this.loading = true;

      if (this.validar() === true) {
        if (this.index === -1) {
          this.$emit("adicionarVeicTransp", this.refVeicTransp);
        } else {
          this.$emit("editarVeicTransp", this.refVeicTransp, this.index);
        }
        hideModal(this.$refs.kt_modal_faturamento_editar_veic_transp);
        this.$emit("exibirModalEditarVeicTransp", false);
      } else {
        await this.$swal.showInvalidAlert("Verifique os avisos!");
      }

      this.loading = false;
    },
    validar() {
      let result = true;

      if (!this.refVeicTransp.placa) {
        this.errosValidacao.placa = "Informe a placa do veículo";
        result = false;
      } else if (this.refVeicTransp.placa.trim().length <= 0) {
        this.errosValidacao.placa = "Informe a placa do veículo";
        result = false;
      }

      if (!this.refVeicTransp.UF) {
        this.errosValidacao.UF = "Informe a UF da placa do veículo";
        result = false;
      } else if (this.refVeicTransp.UF.trim().length <= 0) {
        this.errosValidacao.UF = "Informe a UF da placa do veículo";
        result = false;
      }

      return result;
    },
    cancelar() {
      hideModal(this.$refs.kt_modal_faturamento_editar_veic_transp);
      this.$emit("exibirModalEditarVeicTransp", false);
    },
    nextFocus(id) {
      if (document.getElementById(id) != null) {
        document.getElementById(id).focus();
      }
    },
  },
  mounted() {
    if (this.index >= 0) {
      this.refVeicTransp = JSON.parse(
        JSON.stringify(this.refVeicTranspFaturamento)
      );
    } else {
      this.refVeicTransp = JSON.parse(JSON.stringify(veicTranspInicializado));
    }
    this.errosValidacao = {};

    this.$utils.requestFocus("txtPlaca");
  },
  data() {
    return {
      errosValidacao: [],
      loading: false,
      refVeicTransp: {},
    };
  },
};
</script>

<style>
.modal-overlay {
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  display: flex;
  justify-content: center;
  background-color: #00000042;
}
</style>
